/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	'use strict';
	
	var $window = $(window);
	var breakPoint = 767;
	
	var resizeFlag = false;
	var windowWidth = $window.width();
	var windowHeight = $window.height();
	//var bodyLimitHeight = (windowHeight - 185) * 0.88;
	
	// hamburger
	$('.js-Trigger').click(function () {
	  $(this).toggleClass('active');
	  $('.st-Header_Navi').toggleClass('active').slideToggle(300);
	});
	if (windowWidth > 767) {
	  $('.globalnavi li .anchor a').click(function () {
	    $('.js-Trigger').removeClass('active');
	    $('.st-Header_Navi').removeClass('active').slideUp(300);
	  });
	}
	
	if (windowWidth > 767) {
	  $('.globalnavi .events').hover(function () {
	    $('nav.sub').fadeIn(200);
	  }, function () {
	    $('nav.sub').fadeOut(200);
	  });
	} else {}
	
	//easing-scroll
	$(function () {
	  $('a[href^=#]').click(function () {
	    var speed = 1000;
	    var href = $(this).attr("href");
	    var target = $(href == "#" || href == "" ? 'html' : href);
	    var hh = $('.st-Header').innerHeight();
	    if (windowWidth > 767) {
	      var position = target.offset().top;
	    } else {
	      var position = target.offset().top - hh;
	    }
	    $("html, body").animate({
	      scrollTop: position
	    }, speed, "swing");
	    return false;
	  });
	});
	
	//gototop fixed
	$(function () {
	  var topBtn = $('.st-Footer_Top');
	  topBtn.hide();
	  $(window).scroll(function () {
	    if ($(this).scrollTop() > 100) {
	      topBtn.fadeIn();
	    } else {
	      topBtn.fadeOut();
	    }
	  });
	  topBtn.click(function () {
	    $('body,html').animate({
	      scrollTop: 0
	    }, 1000);
	    return false;
	  });
	});
	
	window.addEventListener('load', function () {
	  // anchor
	  var url = $(location).attr('href');
	  if (url.indexOf("?id=") == -1) {} else {
	    var url_sp = url.split("?id=");
	    var hash = '#' + url_sp[url_sp.length - 1];
	    var target = $(hash);
	    var hh = $('.st-Header').innerHeight();
	    if (windowWidth > 767) {
	      var position = target.offset().top;
	    } else {
	      var position = target.offset().top - hh;
	    }
	    $("html, body").animate({
	      scrollTop: position
	    }, 1000, "swing");
	  }
	});
	
	// $(window).scroll(function() {
	//   if(windowWidth > 1279){
	//     $(".character").children('div').not('.kokoro').each(function(){
	//       var menuTopMargin = 0;
	//       var parentY = $(this).parents('.outer').offset().top;
	//       var parentH = $(this).parents('.outer').height();
	//       var targetScrollValue = parentY - menuTopMargin;
	//       var wScrollvalue = $(window).scrollTop();
	//       var obj = {};
	//       if(wScrollvalue > targetScrollValue){
	//         if(wScrollvalue > (parentY + parentH) - (menuTopMargin +$(this).height() ) ){
	//           if($(this).hasClass('kokoro')){
	//             obj = {
	//               position: "absolute",
	//               top: parentH - $(this).height()
	//             };
	//           }else{
	//             obj = {
	//               position: "absolute",
	//               top: parentH - $(this).height()
	//             };
	//           }
	//         }else{
	//           obj = {
	//             position: "fixed",
	//             top: menuTopMargin
	//           };
	//         }
	//       }else{
	//         obj = {
	//           position: "absolute",
	//           top: "0"
	//         };
	//       }
	//       $(this).css(obj); //cssを適用。
	//     });
	//     $(".character").children('.kokoro').each(function(){
	//       var menuTopMargin = 0;
	//       var parentY = $(this).parents('.outer').offset().top;
	//       var parentH = $(this).parents('.outer').height();
	//       var targetScrollValue = parentY - menuTopMargin;
	//       var wScrollvalue = $(window).scrollTop();
	//       var obj = {};
	//       if(wScrollvalue > targetScrollValue){
	//         if(wScrollvalue > (parentY + parentH) - (menuTopMargin + $(this).height() - 144 ) ){
	//           if($(this).hasClass('kokoro')){
	//             obj = {
	//               position: "absolute",
	//               top: parentH - $(this).height() + 144
	//             };
	//           }else{
	//             obj = {
	//               position: "absolute",
	//               top: parentH - $(this).height()
	//             };
	//           }
	//         }else{
	//           obj = {
	//             position: "fixed",
	//             top: menuTopMargin
	//           };
	//         }
	//       }else{
	//         obj = {
	//           position: "absolute",
	//           top: "0"
	//         };
	//       }
	//       $(this).css(obj); //cssを適用。
	//     });
	//   }
	// });
	
	window.addEventLister('load', function () {
	  // anchor
	  var url = $(location).attr('href');
	  if (url.indexOf("?id=") == -1) {} else {
	    var url_sp = url.split("?id=");
	    var hash = '#' + url_sp[url_sp.length - 1];
	    var tgt = $(hash);
	    var headerHeight = $('.st-Header_Inner').innerHeight();
	    var pos = tgt.offset().top - headerHeight;
	    $("html, body").animate({
	      scrollTop: pos
	    }, 1000, "swing");
	  }
	});
	
	// $(window).load(function (){
	//   $('.idx-Mainvisual').addClass("animated");
	//
	//   $(".js-Scroll_Animation, .idx-Band_Content").each(function(){
	//     var imgPos = $(this).offset().top;
	//     var scroll = $(window).scrollTop();
	//     var windowHeight = $(window).height();
	//     if (scroll > imgPos - windowHeight + windowHeight/10){
	//       $(this).addClass("animated");
	//     } else {}
	//   });
	// });
	
	// $(window).scroll(function (){
	//   var scroll = $(window).scrollTop();
	//   $(".js-Scroll_Animation, .idx-Band_Content").each(function(){
	//     var imgPos = $(this).offset().top;
	//     var windowHeight = $(window).height();
	//     if (scroll > imgPos - windowHeight + windowHeight/10){
	//       $(this).addClass("animated");
	//     } else {}
	//   });
	// });

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// events/app.bundle.js